import enquireJs from 'enquire.js';
import bootstrapBreakpoints from '../grid';

const dispatchEvent = (event: string) => {
    document.dispatchEvent(new Event(event));
    document.dispatchEvent(new Event('smartResize'));
};

export type ScreenSize = keyof typeof bootstrapBreakpoints;
export type ScreenListenerOptions = {
    destroy: boolean
}

export const onVPort = (screenSize: ScreenSize, callback: (Event) => void, options?: ScreenListenerOptions) => {
    if (options?.destroy) {
        document.removeEventListener(`screen-${screenSize}-on`, callback);
    } else {
        document.addEventListener(`screen-${screenSize}-on`, callback);
    }
}

export const offVPort = (screenSize: ScreenSize, callback: (Event) => void, options?: ScreenListenerOptions) => {
    if (options?.destroy) {
        document.removeEventListener(`screen-${screenSize}-off`, callback);
    } else {
        document.addEventListener(`screen-${screenSize}-off`, callback);
    }
}

export default function breakpointEvents() {

    for (let key in bootstrapBreakpoints) {
        const breakPoint = bootstrapBreakpoints[key];
        enquireJs
            .register(`screen and (max-width: ${breakPoint}px)`, {
                match: function () {
                    dispatchEvent(`screen-${key}-on`);
                },
                unmatch: function () {
                    dispatchEvent(`screen-${key}-off`);
                }
            });
    }
}
